import { initKalturaSession, kaltura } from "src/lib/kaltura";
import { CaptionAssetListAction } from "kaltura-typescript-client/api/types/CaptionAssetListAction";
import { KalturaAssetFilter, KalturaAssetFilterArgs } from "kaltura-typescript-client/api/types/KalturaAssetFilter";

const ENDPOINT_URL = process.env.REACT_APP_KALTURA_BASE_URL;

export async function serveCaptionAssetByEntryId(filterBy?: KalturaAssetFilterArgs) {
  const filter = new KalturaAssetFilter(filterBy);
  const ks = await initKalturaSession();

  const response = await kaltura.request(new CaptionAssetListAction({ filter }));
  if (!response) {
    console.error('Unable to get caption asset url from Kaltura API');
    return;
  }

  if (response.totalCount === 0) {
    console.error('No caption asset found.');
    return;
  }

  const assetId = response.objects[0].id;
  return `${ENDPOINT_URL}/api_v3/service/caption_captionasset/action/serve/ks/${ks}/captionAssetId/${assetId}`;
}
